import React from 'react'

import { HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi'
import { FiAlertTriangle } from 'react-icons/fi'

import { useSetExclusiveTabMutation, useUpdateTabsMutation } from '../../layoutApi'

import { Button } from 'common/components/Button/Button'
import { Tooltip } from 'common/components/Tooltip/Tooltip'
import { useAlert } from 'common/components/Alert/hooks/useAlert'

export function TabActionRow({ coachOrgId, selectedTabEntry, handleAddRow, isLoading, isExclusiveTab = false }) {
  const selectedTabId = selectedTabEntry?.[0]
  const selectedTab = selectedTabEntry?.[1]

  const { createAlert } = useAlert()

  const [updateTabs] = useUpdateTabsMutation()
  const [setExclusiveTab] = useSetExclusiveTabMutation()

  const handleTabVisibilityToggle = async (tabId, tab) => {
    const visibilityLevel = tab.visibilityLevel === 'coaches' ? 'anyone' : 'coaches'
    const tabUpdate = { ...tab, visibilityLevel }
    let tabsUpdate = {
      [tabId]: tabUpdate,
    }
    if (isExclusiveTab) {
      await setExclusiveTab({ coachOrgId, tabId, tab: tabUpdate })
    } else {
      await updateTabs({ coachOrgId, tabs: tabsUpdate })
    }

    if (selectedTab.visibilityLevel === 'anyone') {
      createAlert({
        text: isExclusiveTab ? 'Published for coaches only' : 'Tab published for coaches only',
        type: 'success',
      })
    } else {
      createAlert({
        text: isExclusiveTab ? 'Published for everyone' : 'Tab published for everyone',
        type: 'success',
      })
    }
  }

  return (
    <div className='flex flex-row justify-between mb-8'>
      <div className='flex items-center min-h-[28px]'>
        {selectedTabEntry &&
          (selectedTab.visibilityLevel === 'anyone' ? (
            <Tooltip content='Change to for coaches' triggerClasses='flex'>
              <Button
                size='sm'
                variant='secondary'
                onClick={(e) => {
                  e.stopPropagation()
                  handleTabVisibilityToggle(selectedTabId, selectedTab)
                }}
                aria-label='Layout visibility toggle'
              >
                Visible to everyone
                <HiOutlineEye className='cursor-pointer text-gray-500 w-5 h-5 ml-2' />
              </Button>
            </Tooltip>
          ) : (
            <Tooltip content='Change to for everyone' triggerClasses='flex'>
              <Button
                size='sm'
                variant='secondary'
                onClick={(e) => {
                  e.stopPropagation()
                  handleTabVisibilityToggle(selectedTabId, selectedTab)
                }}
                aria-label='Layout visibility toggle'
              >
                Visible to coaches
                <HiOutlineEyeOff className='cursor-pointer text-gray-500 w-5 h-5 ml-2' />
              </Button>
            </Tooltip>
          ))}
        {selectedTabEntry && selectedTab?.visibilityLevel === 'coaches' && (
          <Tooltip
            content='Tab is only visible to coaches for previewing. Tap the eye to make this tab visible to everyone.'
            triggerClasses='ml-2'
          >
            <FiAlertTriangle className='w-5 h-5 text-orange-400' />
          </Tooltip>
        )}
      </div>
      <Button onClick={handleAddRow} size='md' disabled={isLoading}>
        Add row
      </Button>
    </div>
  )
}
